<template>
  <main>
     <div class="account-pages my-5 pt-sm-5">
        <div class="container">
           <div class="row justify-content-center">
              <div class="col-md-8 col-lg-6 col-xl-5">
                 <div class="card overflow-hidden">
                    <div class="bg-soft-primary">
                       <div class="row">
                          <div class="col-7">
                             <div class="text-primary p-4">
                                <h5 class="text-primary"> Reset Password</h5>
                                <p>Reset your password with SpaceMine.</p>
                             </div>
                          </div>
                          <div class="col-5 align-self-end">
                          </div>
                       </div>
                    </div>
                    <div class="card-body pt-0">
                       <div>
                         <div class="avatar-md profile-user-wid mb-4">
                           <span class="avatar-title rounded-circle bg-light">
                             <img src="../../assets/images/spacemine-icon.svg" alt="" height="34">
                           </span>
                         </div>
                       </div>
                       <div class="p-2">
                          <div class="alert alert-success text-center mb-4" role="alert">
                             Please enter your email address. Password reset instructions will be sent to you.
                          </div>
                          <form class="form-horizontal" action="#">
                             <div class="form-group">
                                <label for="useremail">Email Address</label>
                                <input v-model="email" type="email" class="form-control" id="useremail" placeholder="Enter email">
                             </div>
                             <div class="form-group row mb-0">
                                <div class="col-12 text-right">
                                   <button class="btn btn-primary w-md waves-effect waves-light" type="submit">Reset</button>
                                </div>
                             </div>
                          </form>
                       </div>
                    </div>
                 </div>
                 <div class="mt-5 text-center">
                    <p>Remember It ? <router-link :to="{ name: 'login' }" class="font-weight-medium text-primary"> Sign In here</router-link> </p>
                    <p>Copyright &copy; SpaceMine Ltd 2017 - 2020.</p>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </main>
</template>

<script>
export default
{
  name: 'Recover',
  data () {
    return {
      year: (new Date().getFullYear()),
      email: ''
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/auth/Recover.vue